<div class="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6 relative overflow-hidden">
  <app-orderflow-bg class="absolute inset-0 z-0"></app-orderflow-bg>

  <div class="relative z-10 w-full max-w-md rounded-2xl bg-zinc-900/60 border border-zinc-800 shadow-xl shadow-black/40 ring-1 ring-white/5 backdrop-blur px-6 py-8">
    <div class="mb-6 text-center">
      <h1 class="text-2xl font-semibold tracking-tight">PulseTrader</h1>
    </div>

    @if (error()) {
      <div class="mb-4 rounded-xl border border-red-900/60 bg-red-950/40 px-4 py-3 text-sm text-red-200">
        {{ error() }}
      </div>
    }

    @if (success()) {
      <div class="mb-4 rounded-xl border border-emerald-900/60 bg-emerald-950/40 px-4 py-3 text-sm text-emerald-200">
        Anmeldung erfolgreich.
      </div>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
      <div>
        <label class="block text-sm font-medium text-zinc-200 mb-2">E-Mail</label>
        <input
          type="email"
          formControlName="email"
          placeholder="name@example.com"
          class="w-full rounded-xl bg-zinc-950/60 border border-zinc-800 px-4 py-3 text-zinc-100 placeholder:text-zinc-500 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        />

        @if (form.controls.email.touched && form.controls.email.invalid) {
          <p class="mt-2 text-xs text-red-400">Bitte eine gültige E-Mail eingeben.</p>
        }
      </div>

      <div>
        <label class="block text-sm font-medium text-zinc-200 mb-2">Passwort</label>
        <input
          type="password"
          formControlName="password"
          placeholder="••••••••"
          class="w-full rounded-xl bg-zinc-950/60 border border-zinc-800 px-4 py-3 text-zinc-100 placeholder:text-zinc-500 outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        />

        @if (form.controls.password.touched && form.controls.password.invalid) {
          <p class="mt-2 text-xs text-red-400">Passwort muss mindestens 6 Zeichen haben.</p>
        }
      </div>

      <button
        type="submit"
        [disabled]="loading()"
        class="w-full rounded-xl bg-indigo-600 hover:bg-indigo-500 transition px-4 py-3 font-medium shadow-lg shadow-indigo-600/20 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        @if (!loading()) {
          <span>Anmelden</span>
        } @else {
          <span>Anmelden…</span>
        }
      </button>

      <div class="pt-2 text-xs text-zinc-500">
        <span class="text-red-400">*</span> Zugriff nur über freigeschaltete Accounts.
      </div>
    </form>
  </div>
</div>
